<template>
    <teleport to="#destination">
        <div class="modal-backdrop" v-if="props.isOpen" @click="handleBackdropClick" role="dialog" aria-modal="true">
            <div class="modal" @click.stop>
                <div class="modal-content">
                    <p class="title">{{ props.title }}</p>
                    <p class="subtitle">{{ props.subTitleText }}</p>
                </div>
                <button :style="buttonDynamicStyle" @click="() => props.onClick()">
                    {{ props.buttonText }}
                </button>
            </div>
        </div>
    </teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: '',
    },
    subTitleText: {
        type: String,
        default: '',
    },
    buttonText: {
        type: String,
        default: '',
    },
    buttonBgColor: {
        type: String,
        default: '',
    },
    buttonTextColor: {
        type: String,
        default: '#fff',
    },
    onClick: {
        type: Function,
        default: () => {},
    },
});

const buttonDynamicStyle = computed(() => {
    return {
        backgroundColor: props.buttonBgColor === '' ? 'transparent' : props.buttonBgColor,
        color: props.buttonTextColor,
        borderTop: props.buttonBgColor === '' || props.buttonBgColor === '#fff' ? '.1rem solid #E9ECF0' : 'none',
    };
});

const handleBackdropClick = (e: MouseEvent) => {
    if ((e.target as HTMLElement).classList.contains('modal-backdrop')) {
        props.onClick();
    }
};
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* TODO: 전역 스타일로 */
.modal {
    background-color: #fff;
    border-radius: 2rem;
    max-width: 33rem;
    width: 33rem;
    box-shadow: 0 0.25rem 0.625rem rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.3s ease;
}

@media (max-width: 330px) {
    .modal {
        max-width: calc(33rem - 3rem);
        margin: 0 1.5rem;
    }
}

.modal-content {
    /* margin: 1.25rem 0; */
    padding: 3rem 3rem 2.3rem 3rem;
}

.modal-content > p {
    white-space: pre-line;
    word-break: keep-all;
}

.title {
    color: var(--primary-black-21242-e, #21242e);
    text-align: center;
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 1.6875rem */
}

.subtitle {
    color: var(--primary-black-21242-e, #21242e);
    text-align: center;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 400;
    line-height: 170%; /* 1.4875rem */
}

button {
    width: 100%;
    /* height: 6rem; */
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 150%; /* 27px */
    padding: 1rem 0;
    border-radius: 0 0 2rem 2rem;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-1.25rem);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
